import { buildWellnessTilePath, stripWellnessPrefix } from './wellnessRoutes'
import {
  getWellnessTileId,
  getWellnessTileLabel,
  getWellnessTilePolicyId,
} from './wellnessTileTarget'

function getLocationUrl(location) {
  if (!location) return ''
  return `${location.pathname || ''}${location.search || ''}${location.hash || ''}`
}

function titleizeTileId(tileId) {
  if (!tileId) return ''
  return String(tileId)
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
}

export function normalizeWellnessTileTarget(target = {}) {
  const tileId = getWellnessTileId(target)
  if (!tileId) return null

  const policyId = getWellnessTilePolicyId(target)
  return {
    tileId,
    policyId,
    label: getWellnessTileLabel(target, titleizeTileId(tileId)),
    path: buildWellnessTilePath(tileId, policyId),
  }
}

export function getWellnessTileDescriptorFromLocation(location) {
  const pathname = stripWellnessPrefix(location?.pathname || '')
  const match = pathname.match(/^\/tile\/([^/]+)(?:\/([^/]+))?/)
  if (!match) return null

  const tileId = decodeURIComponent(match[1])
  const policyId = match[2] ? decodeURIComponent(match[2]) : ''

  return {
    tileId,
    policyId,
    label: titleizeTileId(tileId),
    path: getLocationUrl(location) || buildWellnessTilePath(tileId, policyId),
  }
}

export function isWellnessTileDrawerLocation(location) {
  return Boolean(location?.state?.wellnessTileDrawer)
}

export function getWellnessTileBackgroundLocation(location) {
  if (!isWellnessTileDrawerLocation(location)) return null
  return location?.state?.backgroundLocation || null
}

export function buildWellnessTileDrawerState(target, location) {
  const tileTarget = normalizeWellnessTileTarget(target)
  if (!tileTarget) return undefined

  const currentDrawer = location?.state?.wellnessTileDrawer
  const backgroundLocation = location?.state?.backgroundLocation || location
  const currentStack = Array.isArray(currentDrawer?.stack) ? currentDrawer.stack : []
  const previousTile = currentDrawer
    ? normalizeWellnessTileTarget(currentDrawer)
    : getWellnessTileDescriptorFromLocation(location)

  const stack = previousTile ? [...currentStack, previousTile] : currentStack

  return {
    backgroundLocation,
    wellnessTileDrawer: {
      ...tileTarget,
      stack,
    },
  }
}

export function getWellnessTileDrawerDepth(location) {
  const stack = location?.state?.wellnessTileDrawer?.stack
  return Math.max(Array.isArray(stack) ? stack.length : 0, 1)
}

export function getPreviousWellnessTileLabel(drawerState) {
  const stack = drawerState?.stack
  if (!Array.isArray(stack) || stack.length === 0) return 'Wellness'
  return stack[stack.length - 1]?.label || titleizeTileId(stack[stack.length - 1]?.tileId)
}
